import isEmptyString from "../utils/isEmptyString";
var validCustomYear = function validCustomYear(yearEntered) {
  var yearEnteredNum = Number(yearEntered);
  var errors;
  if (isEmptyString(yearEntered)) {
    errors = "Year is required.";
  } else if (yearEntered.length !== 4 || isNaN(yearEnteredNum) || yearEnteredNum <= 0) {
    errors = "Valid year required";
  }
  return errors;
};
export default validCustomYear;